import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import { Link, useNavigate } from "react-router-dom";
import PrimaryButton from "../components/PrimaryButton";
import { useDispatch } from "react-redux";
import { addAdminUser } from "../features/superAdminSlice";
import { emailRegex, passwordRegex } from "../utils/validation";
import toast from "react-hot-toast";
import { MobileResponsive } from "./MobileResponsive";
import DynamicMetaComponent from "../components/DynamicMetaTags";

const AddAdmin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "email") {
      if (value === "") {
        setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
      } else if (!emailRegex.test(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          email: "Invalid email address",
        }));
      } else {
        setErrors((prevErrors) => ({ ...prevErrors, email: "" }));
      }
    } else if (name === "password") {
      if (value !== "" && !passwordRegex.test(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          password: "Password should be at least 8 characters long",
        }));
      } else {
        setErrors((prevErrors) => ({ ...prevErrors, password: "" }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.password) {
      toast.error("Please fill in all fields");
      return;
    }

    setErrors({ email: "", password: "" });

    const resultAction = await dispatch(addAdminUser(formData));

    if (resultAction.type.includes("fulfilled")) {
      toast.success("Admin created successfully!!!");
      navigate("/manage-admin");
    }
  };

  return (
    <>
      <DynamicMetaComponent
        pageTitle="Beep - Add Admins & Expand Your Team"
        pageDescription="Empower your team with Beep! Easily add or remove admins to ensure optimal management of your logistics operations and enhance efficiency."
        pageKeywords="Beep, admin management, add admin, delete admin, team empowerment, logistics management"
      />
      <MobileResponsive />
      <div className="lg:flex hidden items-start">
        <Sidebar />

        <div className="ml-[14.5vw] w-full h-screen overflow-y-auto px-10 py-8 text-secondary">
          <div className="flex justify-between w-full">
            <Link to="/manage-admin" className="flex items-center gap-3">
              <div className="bg-[#F75E00] w-5 h-5 flex items-center justify-center rounded-full pr-[1.5px]">
                <img
                  src="/assets/left-white-arrow.svg"
                  alt=""
                  className="w-[6px]"
                />
              </div>
              <span className="font-semibold text-base">Add new Admin</span>
            </Link>
          </div>

          <form
            className="w-[37%] rounded-lg grid grid-cols-1 gap-5 py-8"
            onSubmit={handleSubmit}
          >
            <div>
              <label htmlFor="name" className="font-medium">
                Full name
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Priyanshu Joshi"
                className="border-[2px] rounded-lg w-full px-3 py-2.5 placeholder:font-normal outline-primary text-base font-semibold my-1 shadow-light"
              />
            </div>
            <div>
              <label htmlFor="email" className="font-medium">
                Email address
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="joshi.priyanshu999@gmail.com"
                className={`border-[2px] rounded-lg w-full px-3 py-2.5 placeholder:font-normal outline-primary text-base font-semibold my-1 shadow-light ${
                  errors.email ? "border-[#E00000] focus:border-[#E00000]" : ""
                }`}
              />
              {errors.email && (
                <p className="mt-0.5 text-left text-xs text-[#E00000]">
                  {errors.email}
                </p>
              )}
            </div>
            <div className="relative">
              <label htmlFor="password" className="font-medium">
                Password
              </label>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                placeholder="Enter your password"
                className={`border-[2px] rounded-lg w-full px-3 py-2.5 placeholder:font-normal outline-primary text-base font-semibold my-1 shadow-light pr-12 ${
                  errors.password
                    ? "border-[#E00000] focus:border-[#E00000]"
                    : ""
                }`}
              />
              <img
                src={`/assets/eye${showPassword ? "" : "-close"}.svg`}
                alt={showPassword ? "Hide password" : "Show password"}
                className={`h-5 cursor-pointer absolute right-4 top-1/2 transform -translate-y-1/2 ${
                  formData.password && !errors.password
                    ? "mt-2.5"
                    : formData.password && errors.password
                    ? "mt-0"
                    : "mt-2.5"
                }`}
                onClick={() => setShowPassword(!showPassword)}
              />
              {errors.password && (
                <p className="mt-0.5 text-left text-xs text-[#E00000]">
                  {errors.password}
                </p>
              )}
            </div>
            <div className="flex items-center justify-center gap-5 py-3 w-[35%]">
              <PrimaryButton
                text="Add admin"
                uppercase={false}
                mutation={true}
                width="w-full"
                type="submit"
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddAdmin;
